import { SessionKit } from '@wharfkit/session';
import { WebRenderer } from '@wharfkit/web-renderer';
import { WalletPluginAnchor } from '@wharfkit/wallet-plugin-anchor';
import { WalletPluginCloudWallet } from '@wharfkit/wallet-plugin-cloudwallet';
import { WalletPluginWombat } from '@wharfkit/wallet-plugin-wombat';
import { CHAIN, APP_NAME } from '../config/redeem';

/* Single shared SessionKit instance for the whole app. */
export const sessionKit = new SessionKit({
  appName: APP_NAME,
  chains: [{ id: CHAIN.id, url: CHAIN.url }],
  ui: new WebRenderer(),
  walletPlugins: [
    new WalletPluginAnchor(),
    new WalletPluginCloudWallet({
      supportedChains: [CHAIN.id],
      url: 'https://www.mycloudwallet.com',
      autoUrl: 'https://idm-api.mycloudwallet.com/v1/accounts/auto-accept',
      loginTimeout: 300000,
    }),
    new WalletPluginWombat(),
  ],
});
